import script from "./CommonElButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CommonElButton.vue?vue&type=script&setup=true&lang=js"

import "./CommonElButton.vue?vue&type=style&index=0&id=53bd8e66&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53bd8e66"]])

export default __exports__